export const AUTH_SESSION_VALIDATION_QUERY_KEY = "auth-session-validation";

type AuthSessionExpiredListener = () => void;

const authSessionExpiredListeners = new Set<AuthSessionExpiredListener>();

export function isUnauthorizedError(error: unknown): boolean {
  if (typeof error !== "object" || error === null) return false;

  const candidate = error as { code?: unknown; status?: unknown };
  return candidate.code === "UNAUTHORIZED" || candidate.status === 401;
}

export function notifyAuthSessionExpired(): void {
  for (const listener of authSessionExpiredListeners) listener();
}

export function subscribeAuthSessionExpired(listener: AuthSessionExpiredListener): () => void {
  authSessionExpiredListeners.add(listener);
  return () => authSessionExpiredListeners.delete(listener);
}
